import React from 'react';
import { Box, Card, Typography } from '@mui/material';
import styles from './ContactInfoBox.style';

interface ContactInfoBoxProps {
  postalCode: string;
  address: string;
  phone: string;
}

const ContactInfoBox: React.FC<ContactInfoBoxProps> = ({
  postalCode,
  address,
  phone,
}) => {
  // elevation 0 — the border in contactInfoBox is the card's outline, and MUI's
  // default shadow made this box read differently from its two neighbours,
  // which are plain divs.
  return (
    <Card elevation={0} style={styles.contactInfoBox}>
      <Box style={styles.contentBox}>
        <Typography style={styles.sectionTitle}>تلفن و آدرس</Typography>

        <Box style={styles.infoSection}>
          {/* کد پستی */}
          <Box style={styles.infoItem}>
            <Typography style={styles.label}>کد پستی</Typography>
            <Typography style={styles.value}>{postalCode}</Typography>
          </Box>

          {/* آدرس */}
          <Box style={{ ...styles.infoItem, ...styles.addressItem }}>
            <Typography style={styles.label}>آدرس</Typography>
            <Typography style={styles.value}>{address}</Typography>
          </Box>

          {/* تلفن ثابت */}
          <Box style={styles.infoItem}>
            <Typography style={styles.label}>تلفن ثابت</Typography>
            <Typography style={styles.value}>{phone}</Typography>
          </Box>
        </Box>
      </Box>
    </Card>
  );
};

export default ContactInfoBox;
